<template>
  <el-dialog title="私有文件夹" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <span style="clear:both; display:block; margin-top:-22px; padding-bottom:12px;color:#333;">已创建文件夹  {{ tableData.length }} 个</span>
    <el-table :data="tableData"  border height="205" style="width: 100%">
      <el-table-column prop="id" label="ID" width="50" height="40" />
      <el-table-column prop="folder_path" label="文件夹路径" height="40" />
      <el-table-column label="创建时间" align="center" width="160" height="40">
        <template slot-scope="scope">
          {{ formatTimestamp(scope.row.created_time) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" height="40">
        <template slot-scope="scope">
          <div class="button-container">
            <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span style="padding:50px 0 5px; clear:both; display:block;color:#333;">创建文件夹</span>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ID" :label-width="formLabelWidth" prop="user_id">
            <el-input v-model="dataForm.user_id" disabled autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名" :label-width="formLabelWidth" prop="username">
            <el-input v-model="dataForm.username" disabled autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="服务器编号" :label-width="formLabelWidth" prop="host_id">
            <el-input v-model="dataForm.host_id" disabled autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务器IP" :label-width="formLabelWidth" prop="hostname">
            <el-input v-model="dataForm.hostname" disabled autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="文件夹路径" :label-width="formLabelWidth" prop="folder_path">
            <el-input v-model="dataForm.folder_path" autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">创建</el-button>
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      appTypeList: [],
      tableData: [],
      is_lock: [
        { id: 0, name: '正常' },
        { id: 1, name: '异常' },
      ],
      dataForm: {
        user_id: '',
        host_id: '',
        hostname: '',
        username: '',
        folder_path: '',
      },
      dataRule: {
        folder_path: [{
          required: true,
          message: '请输入文件夹链接',
          trigger: 'blur',
        }],
      },
    }
  },
  methods: {
    init (row, appTypeList) {
      this.visible = true
      this.appTypeList = appTypeList

      this.$nextTick(() => {
        // 修复焦点在带校验的项按回车提交后，再次打开对话框，该项会带有校验提示的问题
        // 而 resetFields 仍然放在关闭对话框时执行，以避免下次打开时，带动画的控件（如checkbox）会闪现之前的结果
        this.$refs.dataForm.clearValidate()

        // 对dataForm的赋值，需要滞后，以免变成默认值，reset时出问题
        this.dataForm.id = row.id
        if (this.dataForm.id != null) {
          this.dataForm = {
            user_id: row.id,
            host_id: row.host_id,
            hostname: row.hostname,
            username: row.username,
          }
          this.fetchData()
        }
      })
    },
    reset () {
      this.$refs.dataForm.resetFields()
    },

    // 表单提交
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const tmp = { ...this.dataForm }

          this.$http.post('/rdbackend/create_folder', tmp, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            this.visible = true
            this.submitLoading = false
            this.$message({
              message: response.data.message,
              type: 'success',
              duration: 1500,
            })
            this.fetchData()
            this.dataForm.folder_path = ''
            // 触发事件
            eventBus.$emit('refresh-list')
          }).catch(error => {
            this.$message({
              message: error.response.data.error,
              type: 'error',
              duration: 1500,
            })
            this.submitLoading = false
          })
        }
      })
    },

    // 获取已创建过的文件夹列表
    async fetchData () {
      try {
        const userId = this.dataForm.user_id
        if (!userId) {
          console.error('user_id is not set')
          return
        }
        const dataRaw = {
          user_id: userId,
        }
        const response = await this.$http.get('/rdbackend/list_folder', {
          params: dataRaw,
        })
        this.tableData = response.data.data || []
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    // 删除
    handleDelete (idx, row) {
      MessageBox('您确定删除用户' + row.id + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          id: row.id,
        }
        this.$http.get('/rdbackend/delete_folder', {
          params: params,
        }).then(resp => {
          this.fetchData() // 更新用户列表
          if (resp.data.code === 200) {
            const message = resp.data.message
            Message({
              message,
              type: 'success',
            })
          } else {
            Message({
              message: '删除失败: ' + resp.data.errmsg,
              type: 'error',
            })
          }
        }).catch(error => {
          console.error('Error deleting user:', error)
          Message({
            message: '删除失败: ' + error.message,
            type: 'error',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    // 转换时间戳
    formatTimestamp (timestamp) {
      if (timestamp) {
        const date = new Date(timestamp * 1000) // 将秒转换为毫秒
        return date.toLocaleString() // 返回本地化的日期和时间字符串
      }
      return ''
    },
  },
}
</script>
<style scoped>
/* 使用更具体的选择器 */
.el-table >>> .el-table__cell {
  padding: 0px 0 !important; /* 调整内边距 */
  vertical-align: middle !important; /* 垂直居中 */
  line-height: 1.5em !important; /* 调整行高 */
}

.el-table >>> .el-table__body tr {
  height: 40px !important; /* 设置行高 */
}
.el-table >>> .el-table__header .el-table__cell {
  padding: 0px 0 !important; /* 调整表头内边距 */
  height: 40px !important; /* 设置表头高度 */
}
</style>
